import bespoke from "../assets/svc-bespoke-security.jpg";
import risk from "../assets/svc-risk-management.jpg";
import tech from "../assets/svc-technical-solutions.jpg";
import travel from "../assets/svc-travel-risk-management.jpg";
import wider from "../assets/svc-wider-risk-management.jpg";
import deliverables from "../assets/svc-strategic-deliverables.jpg";
import bgGlobe from "../assets/bg-globe.jpg";

export const SERVICE_IMAGES = {
  "bespoke-security": bespoke,
  "risk-management": risk,
  "technical-solutions": tech,
  "travel-risk-management": travel,
  "wider-risk-management": wider,
  "strategic-deliverables": deliverables,
};
export { bgGlobe };
